import { RoleId } from "@/entities/role";
import { Policy } from "@/policies";

export interface AdminsEntityUsersPolicyContext {
  userRoleId: unknown;
}

export function isAdminsEntityUsersPolicyContext(
  obj: unknown
): obj is AdminsEntityUsersPolicyContext {
  const tmp = obj as AdminsEntityUsersPolicyContext;

  return tmp.userRoleId !== undefined;
}

export const adminsEntityUsersPolicy: Policy = {
  async can(context: unknown) {
    if (!isAdminsEntityUsersPolicyContext(context)) {
      return false;
    }
    return (
      context.userRoleId == RoleId.SuperAdmin ||
      context.userRoleId == RoleId.Admin ||
      context.userRoleId == RoleId.EntityOficial ||
      context.userRoleId == RoleId.Publisher ||
      context.userRoleId == RoleId.PublicRelation
    );
  },
};
